import { server } from '../config';
import { getBrowser, getPlatform, getSource } from './logger';

export const isProduction = () => {
  const hostname = window.location.hostname || '';
  return hostname.includes('cs.justdial.com') || hostname.includes('234');
};

export const onClickEvent = async (category, action, label) => {
  console.log(`OnClick Category = ${category} action = ${action} label= ${label}`);
  if (!isProduction()) {
    return;
  }
  try {
    // window.ga('send', {
    //   hitType: 'event',
    //   eventCategory: category,
    //   eventAction: `Click-${action}`,
    //   eventLabel: label,
    //   eventValue: 1,
    // });
    window?.dataLayer?.push('send', {
      hitType: 'event',
      eventCategory: category,
      eventAction: `Click-${action}`,
      eventLabel: label,
      eventValue: 1,
    });
  } catch (err) {
    console.error(err);
  }
};

export const onPageEvent = async (urlPath, presentPage) => {
  if (!isProduction()) {
    return;
  }
  try {
    const uniqueId = `&uniqueId=${Math.random().toString(16).slice(2)}`;
    const flag = `&flag=${presentPage}`;
    if (window.ga) {
      window.ga('set', {
        page: urlPath + uniqueId + flag,
        title: presentPage,
      });
      window.ga('send', 'pageview');
    }
  } catch (err) {
    console.error(err);
  }
};

export const logger = async (type, log, csportal = false) => {
  const body = {
    type,
    source: getSource(),
    browser: getBrowser(),
    platform: getPlatform(),
    log,
  };
  try {
    if (csportal && !isProduction()) {
      return {};
    }
    const url = `${csportal ? server.apiURL : server.apiURL}wrapper/postlogs`;
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
      credentials: 'include',
    };
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    return data;
  } catch (err) {
    throw new Error(err.message || 'Error sending data');
  }
};
